import axios from "axios";


export default {
    namespaced: true,
    state: {
        banks: [],
        loading: null,
        companyBankAccounts: [],
        companyTransactions: [],
        companyBankAccountNames: {},
        tableOptions: null,
        companyTransactionsCount: 0,
        bankLogs: [],
        aisCompanyLogs: [],
        activeLogSwift: null,
        activeAccount: {},
        activeCompany: null,
    },
    mutations: {
        setBanks(state, val) {
            state.banks = val;
        },
        setCompanyBankAccounts(state, val) {
            val.forEach(a => {
                let name = "-"
                if (a.owner_name && a.account_name) name = `${a.owner_name} (${a.account_name})`;
                else if (a.owner_name) name = `${a.owner_name}`;
                else if (a.account_name) name = `${a.account_name}`;
                state.companyBankAccountNames[a.id] = name;
            });
            state.companyBankAccounts = val;
        },
        setCompanyTransactions(state, val) {
            state.companyTransactions = val;
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setTransactionTableOptions(state, val) {
            state.tableOptions = val;
        },
        setCompanyTransactionsCount(state, val) {
            state.companyTransactionsCount = val;
        },
        setBankLogs(state, val) {
            state.bankLogs = val;
        },
        setAisCompanyLogs(state, val) {
            state.aisCompanyLogs = val;
        },
        setActiveLogSwift(state, val) {
            state.activeLogSwift = val;
        },
        resetActiveLogSwift(state) {
            state.activeLogSwift = null;
            state.bankLogs = [];
            state.aisCompanyLogs = [];
        },
        setActiveAccount(state, val) {
            state.activeAccount = val;
        },
        resetActiveAccount(state) {
            state.activeAccount = {};
        },
        setActiveCompany(state, value) {
            state.activeCompany = value;
        },
        resetActiveCompany(state) {
            state.activeCompany = null;
        },
    },
    actions: {
        async getBanks({commit, state}) {
            commit("setLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                const params = {'activeCompany': state.activeCompany};
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/banks/`, {params});
                const data = response.data;
                if (data.success === 1) {
                    commit("setBanks", data.banks);
                } else {
                    commit("setBanks", []);
                    if (data.msg) {
                        commit("setRequestError", true, {root: true});
                        commit("setErrorMessage", data.msg, {root: true});
                    }
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            commit("setLoading", false);
        },
        async getCompanyAccountsData({commit, state}) {
            await commit("setLoading", true);
            await commit("setRequestSuccess", false, {root: true});
            await commit("setRequestError", false, {root: true});
            try {
                const params = {'activeCompany': state.activeCompany};
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/company-bank-accounts/`, {params});
                const data = response.data;
                if (data.success === 1) {
                    await commit("setCompanyBankAccounts", data.company_bank_accounts);
                } else {
                    await commit("setCompanyBankAccounts", []);
                    if (data.msg) {
                        await commit("setRequestError", true, {root: true});
                        await commit("setErrorMessage", data.msg, {root: true});
                    }
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                await commit("setRequestError", true, {root: true});
                await commit("setErrorMessage", "Failed", {root: true});
            }
            await commit("setLoading", false);
        },
        async getLogsData({commit, state}, {swift}) {
            await commit("setRequestSuccess", false, {root: true});
            await commit("setRequestError", false, {root: true});
            try {
                const params = {'activeCompany': state.activeCompany};
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/logs/${swift}/`, {params});
                const data = response.data;
                if (data.success === 1) {
                    await commit("setBankLogs", data.bank_logs);
                    await commit("setAisCompanyLogs", data.ais_company_logs);
                } else {
                    await commit("setBankLogs", []);
                    await commit("setAisCompanyLogs", []);
                    if (data.msg) {
                        await commit("setRequestError", true, {root: true});
                        await commit("setErrorMessage", data.msg, {root: true});
                    }
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                await commit("setRequestError", true, {root: true});
                await commit("setErrorMessage", "Failed", {root: true});
            }
        },
        async getCompanyTransactions({commit, state}) {
            await commit("setLoading", true);
            await commit("setRequestSuccess", false, {root: true});
            await commit("setRequestError", false, {root: true});
            try {
                const options = state.tableOptions;
                const params = {
                    page: options && options.page ? options.page : null,
                    itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : null,
                    sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                    sortDesc: options && options.sortDesc ? options.sortDesc[0] : null,
                    activeCompany: state.activeCompany

                };
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/company-transactions/`, {params});
                const data = response.data;
                if (data.success === 1) {
                    await commit("setCompanyTransactions", data.company_transactions);
                    await commit("setCompanyTransactionsCount", data.count || 0);
                } else {
                    await commit("setCompanyTransactions", []);
                    await commit("setCompanyTransactionsCount", 0);
                    if (data.msg) {
                       await commit("setRequestError", true, {root: true});
                        await commit("setErrorMessage", data.msg, {root: true});
                    }
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                await commit("setRequestError", true, {root: true});
                await commit("setErrorMessage", "Failed", {root: true});
            }
            await commit("setLoading", false);
        },
        async togglePullAccount({commit, state}, {id, value}) {
            try {
                const body = {id, value};
                const params = {'activeCompany': state.activeCompany};
                const response = await axios.put(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/toggle-pull-account/`, body, {params});
                const data = response.data;
                let isSuccessful = false
                if (data.success === 1) isSuccessful = true;
                return isSuccessful
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                await commit("setRequestError", true, {root: true});
                await commit("setErrorMessage", "Failed", {root: true});
            }
            return false
        },
        async downloadAccountData({commit, state}, {accountId, transactionDays}) {
            try {
                await commit("setRequestSuccess", false, {root: true});
                await commit("setRequestError", false, {root: true});
                const params = {
                    transaction_days: transactionDays,
                    activeCompany: state.activeCompany
                }
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/download-account-data/${accountId}/`, {params});
                const data = response.data;
                let isSuccessful = false
                if (data.success === 1) {
                    isSuccessful = true
                    await commit("setRequestSuccess", true, {root: true});
                } else {
                    await commit("setErrorMessage", data.msg ? data.msg : 'Failed', {root: true});
                    await commit("setRequestError", true, {root: true});
                }
                return isSuccessful
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                await commit("setRequestError", true, {root: true});
                await commit("setErrorMessage", "Failed", {root: true});
            }
            return false
        },
        async getCompanyBankAccountData({commit, state}, accountId) {
            await commit("setLoading", true);
            await commit("setRequestSuccess", false, {root: true});
            await commit("setRequestError", false, {root: true});
            try {
                const params = {activeCompany: state.activeCompany};
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/company-bank-account/${accountId}/`, {params});
                const data = response.data;
                if (data.success === 1) {
                    await commit("setActiveAccount", data.company_bank_account);
                } else {
                    await commit("setActiveAccount", {});
                    if (data.msg) {
                        await commit("setRequestError", true, {root: true});
                        await commit("setErrorMessage", data.msg, {root: true});
                    }
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                await commit("setRequestError", true, {root: true});
                await commit("setErrorMessage", "Failed", {root: true});
            }
            await commit("setLoading", false);
        },
    }
}